import {
  doGETRequest,
  doPOSTRequest,
  doPUTRequest
} from "./Api";
import { OrderAction } from "./dto/OrderAction";

class OrderActionApi {
  
  public static async onAction(action:OrderAction, orderId:Number) {
    const relativePath = "/order-action/"+OrderAction[action]+"?id="+orderId;
    var response = await doPUTRequest(relativePath, {});
    return response;
  }

}

export default OrderActionApi;
